import FLAG from 'config/flag.singleton';
import fromAnyToBool from 'utils/converters/fromAnyToBool.util';
import { fromAnyDateToIso } from 'utils/converters/time/from.util';
import withOptions from 'utils/functions/withOptions.util';
import logger from 'utils/logger.util';
import asObject from 'utils/objects/asObject.util';

const L = logger('determineBookingTime');

const USE_SPAM_LOG = fromAnyToBool(FLAG.loggerSpam);

const determineBookingTime = withOptions(({ booking, stylistId }) => {
  const { startTime, currentStylistId, type } = asObject(booking);
  if (!startTime) return '';

  const isCurrentStylist = currentStylistId === stylistId;
  if (!isCurrentStylist) return '';

  const result = fromAnyDateToIso(startTime);
  if (USE_SPAM_LOG) L.debug('()', result, '<-', { stylistId, type });

  return result;
});

export default determineBookingTime;
